
//36
Object.defineProperty(exports, "__esModule", { value: true });
require("./Badge.st.css");
module.exports.default = require("stylable/runtime").create(
    "root",
    "BadgeStyle2102042553",
    {"root":"BadgeStyle2102042553--root","backgroundColor":"grey","borderColor":"grey","color":"white"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/components/deprecated/stylable-badge/BadgeStyle.st.css
// module id = 1301
// module chunks = 0